<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12">
                <b-button v-on:click="goBack" variant="secondary">
                    <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                </b-button>
            </b-col>
        </b-row>
        <div v-if="companiesListMode" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <h1>Groups</h1>
                </b-col>
            </b-row>
            <CompaniesBlockSelection v-on:company-selected="companySelected" />
        </div>
        <div v-if="areasListMode" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <h1>Areas</h1>
                </b-col>
            </b-row>
            <AreasBlockSelection v-on:area-selected="areaSelected" v-on:selection-completed="areaSelectionComplete" :company="selectedCompany" />
        </div>
        <div v-if="sitesListMode" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <h1>Sites</h1>
                </b-col>
            </b-row>
            <SitesBlockSelection v-on:site-selected="siteSelected" v-on:selection-completed="siteSelectionComplete" :area="selectedArea" />
        </div>
        <div v-if="areaMoveProcess" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <h1>Area(s) Move</h1>
                </b-col>
            </b-row>
            <AreaMoveProcess v-on:move-completed="moveCompleted" :selected-areas="areasToMove" />
        </div>
        <div v-if="siteMoveProcess" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <h1>Site(s) Move</h1>
                </b-col>
            </b-row>
            <SiteMoveProcess v-on:move-completed="moveCompleted" :selected-sites="sitesToMove" />
        </div>
    </div>
</template>

<script>

import CompaniesBlockSelection from '@/components/data-control/hierarchy/CompaniesBlockSelection.vue';
import AreasBlockSelection from '@/components/data-control/hierarchy/AreasBlockSelection.vue';
import SitesBlockSelection from '@/components/data-control/hierarchy/SitesBlockSelection.vue';
import AreaMoveProcess from '@/components/data-control/hierarchy/AreaMoveProcess.vue';
import SiteMoveProcess from '@/components/data-control/hierarchy/SiteMoveProcess.vue';

export default {
  name: 'MoveHierarchyEntities',
  components: {
      CompaniesBlockSelection: CompaniesBlockSelection,
      AreasBlockSelection: AreasBlockSelection,
      SitesBlockSelection: SitesBlockSelection,
      AreaMoveProcess: AreaMoveProcess,
      SiteMoveProcess: SiteMoveProcess
  },
  data () {
    return {
        companiesListMode: true,
        areasListMode: false,
        sitesListMode: false,
        usersListMode: false,
        selectedCompany: '',
        selectedArea: '',
        selectedSite: '',
        areaMoveProcess: false,
        areasToMove: [],
        siteMoveProcess: false,
        sitesToMove: []
    }
  },
  methods: {
    goBack() {
        console.log('companies list mode: ', this.$data.companiesListMode);
        console.log('areas list mode: ', this.$data.areasListMode);
        console.log('sites list mode: ', this.$data.sitesListMode);
        console.log('users list mode: ', this.$data.usersListMode);
        if (this.$data.areasListMode) {
            this.$data.areasListMode = false;
            this.$data.sitesListMode = false;
            this.$data.companiesListMode = true;
        }
        else if (this.$data.sitesListMode) {
            this.$data.areasListMode = true;
            this.$data.sitesListMode = false;
            this.$data.companiesListMode = false;
        }
        else if (this.$data.usersListMode) {
            this.$data.areasListMode = false;
            this.$data.sitesListMode = true;
            this.$data.companiesListMode = false;
        }
        else {
            this.$router.push('/data-control');
        }
        
    },
    moveCompleted() {
        this.$data.areaMoveProcess = false;
        this.$data.siteMoveProcess = false;
        this.$router.push('/data-control');
    },
    companySelected(company) {
        this.$data.selectedCompany = company;
        this.$data.companiesListMode = false;
        this.$data.areasListMode = true;
    },
    areaSelected(area) {
        this.$data.selectedArea = area;
        this.$data.areasListMode = false;
        this.$data.sitesListMode = true;
    },
    siteSelected(site) {
        this.$data.selectedSite = site;
        this.$data.sitesListMode = false;
    },
    areaSelectionComplete(selectedAreas) {
        // this means the users has chosen areas to move
        // just update the selected area data, the cascading down happens in the API
        this.$data.areasListMode = false;
        this.$data.areasToMove = selectedAreas;
        this.$data.areaMoveProcess = true;
        
    },
    siteSelectionComplete(selectedSites) {
        this.$data.sitesListMode = false;
        this.$data.sitesToMove = selectedSites;
        this.$data.siteMoveProcess = true;
    }
  }
}
</script>
